import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {fragments}      from "@Common/react/fragments";
import {Invoke}         from "@Common/react/invoke";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";

export const OfficeAdminLayoutLoader = ({next}) => cs(
    consumeContext("apis"),
    ["officeId", (_, next) => UseState({next})],
    ["office", ({apis, officeId}, next) => Load2({
        _key: officeId.value,
        fetch: () => !officeId.value ? null : apis.next.session.getBranch({officeId: officeId.value}),
        next,
    })],
    ({office, officeId}) => React.createElement(
        Context.Provider,
        {
            value: {
                loadData: ({officeId: officeId1, next}) => fragments(
                    officeId1 !== officeId.value && Invoke({
                        action: () => officeId.onChange(officeId1),
                    }),

                    next({
                        loading: office.loading || office.value == null,
                        office: office.value,
                        clear: () => officeId.onChange(null),
                        reload: office.reload
                    })
                )
            },
        },
        next(),
    ),
);

export const Context = React.createContext(null);
